import Gndu from '../images/UniversityImages/gndu.png'
import SVM from '../images/UniversityImages/svm.png'
import Lpu from '../images/UniversityImages/Lovely_Professional_University_logo.png'
import SchoolIcon from '@mui/icons-material/School';
import TerminalIcon from '@mui/icons-material/Terminal';
import RedeemIcon from '@mui/icons-material/Redeem';
export const educations = [
  {
    programs: [
      {
        name: "Master's In Computer Application",
        location: 'Phagwara, Punjab,India',
        university: 'LPU(Lovely Professional University)',
        completed: 'ongoing',
        // image: Lpu,
        icon:<RedeemIcon/>,
        info: `I am currently pursuing a Master's degree in Computer Application  at Lovely professional University, Phagwara, Jalandhar. I have completed 2 semesters and have a CGPA of 6.5.  i have taken courses in Data Science, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.`,
      },
      
      {
        name: 'Full Stack Development',
        university: 'JSpider/QSpider',
        location: 'Noida, Up, India',
        icon:<TerminalIcon/>,

        // image: 'https://jspiders.com/_nuxt/img/logo_jspiders.3b552d0.png',
        completed: '2023',
        info:`I completed Full Stack Development Course  from Jspider, Noida , Up. where I studied  Spring-boot, Core-Java, Html,  Css, JavaScript, SQl, Servlet, Hibernate, MySql , among other.`
      },

      {
        name: 'Bachelor of Computer Applications',
        location: 'Amritsar, Punjab, India',
        university: 'GNDU(Guru Nanak Dev university)',
        completed: '2022',
        icon:<RedeemIcon/>,

        // image: Gndu,
        info:`I completed my Bachelor's degree in Computer Application from Guru Nanak Dev University, Amritsar , Punjab. where I studied C , C++ , Java , Html Css , JavaScript , DataBase Management System , Computer Networking , Discreate Mathematics , among other.`
      },

      {
        name: 'Higher Schooling',
        location: 'Pathankot, Punjab, India',
        university: 'AMSS(Adarsh  Modern Senior Secondary School)',
        completed: '2019',
        icon:<SchoolIcon/>,

        // image: 'https://www.amssschool.com/assets/images/logo.png',
        info:` Completed my class 12 high school education at Adarsh Modern Sen. Sec. School, Narot mehra, Pathankot, Punjab. where I studied Computer Science, among other.`

      },

      {
        name: 'Secondary Schooling',
        location: 'Pathankot, Punjab, India',
        university: 'SVM(Sarvhitkari Vidya Mandir)',
        completed: '2015',
        icon:<SchoolIcon/>,

        // image:SVM,
        info:`I completed my class 10 education at Sarvhitkari vidya Mandir , Bhoa, where I studied Science , Maths with Computer Science., among other.`

      },
    ],
  },
];
